<template>
  <div>
    <ativar-ou-inativar-associacao-dialog
      :is-ativar-ou-inativar-associacao-dialog-open.sync="isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen"
      :is-associacao-ativa-mensagem="isAssociacaoAtivaMensagem"
      :loading="loading"
      :close-dialog="closeDialog"
      :confirmar-ativacao-ou-inativacao-da-associacao="confirmarAtivacaoOuInativacaoDaAssociacao"
      @refetch-data="$emit('refetch-data')"
    />

    <v-data-table
      no-data-text="Sem dados"
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      @click:row="selectAssociacao"
    >
      <template #[`item.departamentoNome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.departamentoNome.toUpperCase().charAt(0) }}{{ item.departamentoNome.toUpperCase().charAt(1) }}
            </span>
          </v-avatar>

          <div class="d-flex flex-column ms-3">
            {{ item.departamentoNome }}
          </div>
        </div>
      </template>

      <template #[`item.status`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
            >
              <v-icon @click="ativarOuInativarAssociacaoItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ item.ativo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>

                <span class="text-capitalize"> {{ getMensagemAtivacaoOuInativacao(item) }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiCloseThick, mdiDotsVertical, mdiCheckBold } from '@mdi/js'
import AtivarOuInativarAssociacaoDialog from '@/views/ativar-ou-inativar-associacao-dialog/AtivarOuInativarAssociacaoDialog.vue'
import CargoService from '@/services/modules/CargoService'

export default {
  components: {
    AtivarOuInativarAssociacaoDialog,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargoId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen = ref(false)

    const loading = ref(false)
    const departamentoId = ref(null)
    const isAssociacaoAtiva = ref(undefined)
    const isAssociacaoAtivaMensagem = ref('')

    function getMensagemAtivacaoOuInativacao(item) {
      return item.ativo ? 'inativar' : 'ativar'
    }

    function ativarOuInativarAssociacaoItem(item) {
      departamentoId.value = item.departamentoId
      isAssociacaoAtiva.value = item.ativo
      isAssociacaoAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }
    function openAssociarOuDesassociar() {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen.value = true
    }
    function closeDialog() {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen.value = false
    }
    async function confirmarAtivacaoOuInativacaoDaAssociacao() {
      if (loading.value) return
      try {
        loading.value = true
        await CargoService.ativarOuInativarAssociacaoCargoDepartamento(props.cargoId, departamentoId.value, { ativar: !isAssociacaoAtiva.value })
        emit('refetch-data')
      } finally {
        closeDialog()
        loading.value = false
      }
    }

    const isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen = ref(false)
    const associacaoSelecionada = ref(null)

    function selectAssociacao(item) {
      if (!item.ativo) return
      associacaoSelecionada.value = item
      isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen.value = true
    }

    const headers = [
      { text: 'NOME', value: 'departamentoNome' },
      { text: 'DEPARTAMENTO', value: 'departamentoDescricao' },
      { text: 'STATUS', value: 'status' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen,
      loading,
      isAssociacaoAtiva,
      isAssociacaoAtivaMensagem,
      getMensagemAtivacaoOuInativacao,
      ativarOuInativarAssociacaoItem,
      openAssociarOuDesassociar,
      closeDialog,
      confirmarAtivacaoOuInativacaoDaAssociacao,
      isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen,
      associacaoSelecionada,
      selectAssociacao,
      icons: {
        mdiCloseThick,
        mdiDotsVertical,
        mdiCheckBold,
      },
      headers,
    }
  },
}
</script>
